import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const preventPinchZoom = () => {
  const blockGesture = (event) => {
    event.preventDefault();
  };

  const blockZoomWheel = (event) => {
    if (event.ctrlKey) {
      event.preventDefault();
    }
  };

  const blockMultiTouch = (event) => {
    if (event.touches && event.touches.length > 1) {
      event.preventDefault();
    }
  };

  document.addEventListener('touchstart', blockMultiTouch, { passive: false });
  document.addEventListener('touchmove', blockMultiTouch, { passive: false });
  document.addEventListener('gesturestart', blockGesture, { passive: false });
  document.addEventListener('gesturechange', blockGesture, { passive: false });
  document.addEventListener('gestureend', blockGesture, { passive: false });
  window.addEventListener('wheel', blockZoomWheel, { passive: false });
};

preventPinchZoom();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
